import { Box } from "@mui/material";

export const RACTDetailsImage = ({
  url,
  alt,
  containerStyle = {},
  imgStyle = {},
}) => {
  return (
    <Box
      sx={{
        width: "400px",
        height: "200px",
        borderRadius: 1,
        ...containerStyle,
      }}
    >
      <img
        style={{
          width: "100%",
          height: "200px",
          maxHeight: "200px",
          objectFit: "cover",
          ...imgStyle,
        }}
        alt={alt}
        src={url}
      />
    </Box>
  );
};
